"use client";

import React, { createContext, useContext } from "react";
import { useABTestTracking } from "@/hooks/use-ab-tests";

const AB_TEST_NAME = "pricing-layout-test-1" as const;

const PRICE_PAGE_VARIANTS = ["pricing-a", "pricing-b"] as const;
type PricePageVariant = (typeof PRICE_PAGE_VARIANTS)[number];

const checkPricePageVariant = (input: string): PricePageVariant | undefined =>
  PRICE_PAGE_VARIANTS.includes(input as PricePageVariant)
    ? (input as PricePageVariant)
    : undefined;

interface ABTestPricePageState {
  variant?: PricePageVariant;
  isLoading: boolean;
  trackABConversion: (planName: string) => void;
}

const ABTestPricePageContext = createContext<ABTestPricePageState | null>(null);

export const useABTestPricePageContext = (): ABTestPricePageState => {
  const context = useContext(ABTestPricePageContext);
  if (!context) {
    throw new Error(
      "useABTestPricePageContext must be used within a ABTestPricePageProvider",
    );
  }
  return context;
};

const ABTestPricePageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { variant, isLoading, trackConversion } =
    useABTestTracking(AB_TEST_NAME);
  const trackABConversion = (planName: string) => {
    trackConversion("ab-test-conv-pricing-1-on-click-btn", {
      planName,
    });
  };

  return (
    <ABTestPricePageContext.Provider
      value={{
        // variant: variant === null ? undefined : checkPricePageVariant(variant),
        // isLoading: isLoading,
        variant: "pricing-a",
        isLoading: false,
        trackABConversion,
      }}
    >
      {children}
    </ABTestPricePageContext.Provider>
  );
};

export default ABTestPricePageProvider;
